import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Set up global configurations for admin subdomain
window.ADMIN_APP = true;
window.SUBDOMAIN = 'admin';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);